import { Address, User } from '@app/models';
import { Action } from '@ngrx/store';

export interface UpdateUserPayload {
  user: User;
  additionalActions: Action[];
}

export enum UserActionTypes {
  UserUpdateGdpr = '[User] Update GDPR',
  UserUpdateGdprSuccess = '[User] Update GDPR Success',
  UserUpdateGdprFailure = '[User] Update GDPR Failure',
  UserRedirectToHomePage = '[User] Redirect to home page',
  UserGoBack = '[User] Go back',
  UserUpdateAddress = '[User] User Update Address',
  UserUpdateAddressFailure = '[User] User Update Address Failure',
  UpdateUser = '[User] Update User',
  UpdateUserFailure = '[User] Update User Failure',
  ResetUserDefaultFilter = '[User] Rest User Default Filter',
  UserGoToGtc = '[User] User Go to GTC',
  UserToGoPaPSearch = '[User] Go To PaP Search'
}

export class UserUpdateGdpr implements Action {
  readonly type = UserActionTypes.UserUpdateGdpr;

  constructor(public payload: any) {
  }
}

export class UserUpdateGdprSuccess implements Action {
  readonly type = UserActionTypes.UserUpdateGdprSuccess;
}

export class UserUpdateGdprFailure implements Action {
  readonly type = UserActionTypes.UserUpdateGdprFailure;
}

export class UserRedirectToHomePage implements Action {
  readonly type = UserActionTypes.UserRedirectToHomePage;
}

export class UserGoBack implements Action {
  readonly type = UserActionTypes.UserGoBack;
}

export class UserUpdateAddress implements Action {
  readonly type = UserActionTypes.UserUpdateAddress;

  constructor(public payload: { address: Address; redirectAction: Action }) {
  }
}

export class UserUpdateAddressFailure implements Action {
  readonly type = UserActionTypes.UserUpdateAddressFailure;
}

export class UpdateUser implements Action {
  readonly type = UserActionTypes.UpdateUser;

  constructor(public payload: UpdateUserPayload) {
  }
}

export class UpdateUserFailure implements Action {
  readonly type = UserActionTypes.UpdateUserFailure;
}

export class ResetUserDefaultFilter implements Action {
  readonly type = UserActionTypes.ResetUserDefaultFilter;

  constructor(public payload: number) {
  }
}

export class UserGoToGtc implements Action {
  readonly type = UserActionTypes.UserGoToGtc;

  constructor(public payload: number) {
  }
}

export class UserToGoPaPSearch implements Action {
  readonly type = UserActionTypes.UserToGoPaPSearch;
}

export type UserActions =
  | UserUpdateGdpr
  | UserUpdateGdprSuccess
  | UserUpdateGdprFailure
  | UserRedirectToHomePage
  | UserGoBack
  | UserUpdateAddress
  | UserUpdateAddressFailure
  | UpdateUser
  | UpdateUserFailure
  | ResetUserDefaultFilter
  | UserGoToGtc
  | UserToGoPaPSearch;
